import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ModalController, PopoverController } from '@ionic/angular';
import { DataService } from 'src/app/services/data.service';
import { OktaService } from 'src/app/services/okta.service';
import { PopoverComponent } from './popover/popover.component';
import { StorageService } from 'src/app/services/storage.service';
import { TemperatureService } from 'src/app/services/temperature.service';
import { LanguageService } from 'src/app/services/language.service';

@Component({
  selector: 'app-user-settings',
  templateUrl: './user-settings.component.html',
  styleUrls: ['./user-settings.component.scss'],
  standalone: false
})
export class UserSettingsComponent implements OnInit {

  selectedOption: boolean = false;
  languages: any;
  selectedLanguage: any;
  form!: FormGroup;

  // isLoggedIn: boolean = false;

  constructor(private fb: FormBuilder, private oktaService: OktaService, private dataService: DataService,
    private popoverCtrl: PopoverController, private modalController: ModalController,
    private storageService: StorageService, private temperatureService: TemperatureService, private languageService: LanguageService
  ) {
    // this.oktaService.isAuth
  }

  async ngOnInit() {
    this.form = this.fb.group({
      selectedLanguage: [null],
      roundingAll: [false],
      frameParts: [false],
      correctionFactor: [false],
      temperatureUnit: [false]
    });
    try {
      // const projectRes = await this.storageService.getProject();
      // if (projectRes) {
      //   const project = JSON.parse(projectRes);
      //   const userSettings = project.userSettings || {};

      //   // Convert stored string → boolean for toggle
      //   this.form.patchValue({
      //     temperatureUnit: userSettings.temperatureUnit === 'fahrenheit'
      //   });
      // }
      const unit = await this.temperatureService.getTemperatureUnit();
      this.form.patchValue({
        temperatureUnit: unit === 'fahrenheit'
      });
    } catch (error) {
      console.warn('Temperature unit load failed, defaulting to Celsius:', error);
    }

    // const userAuth = await this.oktaService.isUserAuthenticated();
    // this.isLoggedIn = userAuth;

    this.dataService.getLanguages().subscribe({
      next: (data) => {
        this.languages = data || [];
        this.patchSelectedLanguage();
      },
      error: (err) => console.error('Failed to load countries', err)
    });

    this.form.valueChanges.subscribe(() => {
      this.selectedOption = this.form.dirty;
    });
  }

  private patchSelectedLanguage() {
    const currentCode = this.languageService.getCurrentLanguage() || 'en-GB';

    this.selectedLanguage =
      this.languages.find((item: any) => item.code === currentCode) ||
      this.languages.find((item: any) => item.code === 'en-GB') ||
      null;
    console.log("selectedLanguage", this.selectedLanguage);
    this.form.patchValue(
      {
        selectedLanguage: this.selectedLanguage
      },
      { emitEvent: false }
    );
  }

  closeLogin() {
    this.modalController.dismiss(null, 'cancel');
  }

  async validate() {
    const formValue = this.form.value;
    const lang = this.selectedLanguage?.code || 'en-GB';
    this.languageService.setLanguage(lang);
    await this.temperatureService.setTemperatureUnit(
      formValue.temperatureUnit ? 'fahrenheit' : 'celsius'
    );

    // Save other settings normally (if project-specific)
    // await this.storageService.updateProject({
    //   userSettings: {
    //     roundingAll: formValue.roundingAll,
    //     frameParts: formValue.frameParts,
    //     correctionFactor: formValue.correctionFactor
    //   }
    // });
    this.modalController.dismiss(formValue);
  }
  onTemperatureUnitChange(isChecked: boolean) {
    console.log('Toggle changed:', isChecked ? 'Fahrenheit' : 'Celsius');
  }

  async openLanguagePopover(ev: any) {
    const popover = await this.popoverCtrl.create({
      component: PopoverComponent,
      event: ev,
      translucent: true,
      componentProps: { languages: this.languages }
    });

    popover.onDidDismiss().then(result => {
      if (result.data) {
        console.log(result.data)
        this.selectedLanguage = result.data;
        // this.form.patchValue({
        //   selectedLanguage: result.data,
        // });
        this.form.get('selectedLanguage')?.setValue(
          { ...result.data },   // new object reference
          { emitEvent: true }
        );
        this.form.markAsDirty();
        this.form.updateValueAndValidity();
      }
    });

    await popover.present();
  }
}
